import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/auth.store";

/**
 * Auth-only route guard (docs/305 §4.3, §1.2). Admin roles are flat, so this
 * checks authentication ONLY — no role/permission logic. Unauthenticated
 * visitors are redirected to /login.
 */
export default function ProtectedRoute({ children }: { children: ReactNode }): JSX.Element {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
